import { Button } from '@zoom/react-ui'
import { StaticFileIconsConstant } from '../constants'
import { IconFileFormatDocument } from '@zoom/icons-react'
import { useAppDispatch, useAppSelector, useIsSharer } from '../hooks'
import { selectApp, setIsNavigatingDuringCollab } from '../app/root'
import { CollabFile, selectCollabFile } from '../app/collabFile'
import { useEffect, useState } from 'react'

const JoinCollaboration = () => {
  const dispatch = useAppDispatch()
  const app = useAppSelector(selectApp)!
  const [autoOpened, setAutoOpened] = useState(false)
  const { fileUrl, fileType, fileName } = useAppSelector(
    selectCollabFile
  ) as CollabFile
  const isSharer = useIsSharer(app)

  useEffect(() => {
    if (isSharer !== undefined && !isSharer && !autoOpened) {
      zoomSdk.openUrl({
        url: fileUrl,
      })
      setAutoOpened(true)
    }
  }, [fileUrl, isSharer, autoOpened, setAutoOpened])

  const handleReopenDocument = async () => {
    await zoomSdk.openUrl({
      url: fileUrl,
    })
  }

  const handleBackToHome = () => {
    dispatch(setIsNavigatingDuringCollab(true))
  }

  return (
    <div className='flex h-screen flex-col items-center justify-center px-4'>
      <div className='max-w-[540px]'>
        <div className='flex gap-2 px-4 py-3'>
          <div className='h-6 w-6 shrink-0'>
            {StaticFileIconsConstant[app][fileType] || (
              <IconFileFormatDocument
                color='#3B90F7'
                size='large'
              />
            )}
          </div>

          <p className='break-words break-all text-sm font-normal text-[#6E7680]'>
            {fileName}
          </p>
        </div>

        <h1 className='mb-6 mt-4 text-center text-base font-[590]'>
          Joined collaboration in system browser
        </h1>

        <div className='flex items-center justify-center gap-2'>
          <Button onClick={handleReopenDocument}>Re-open document</Button>
          <Button
            onClick={handleBackToHome}
            type='secondary'
          >
            Back to home
          </Button>
        </div>
      </div>
    </div>
  )
}

export default JoinCollaboration
